import React from "react";
import { TrendingUp, LayoutGrid, Route, ExternalLink } from "lucide-react";
import { CAREERS, COURSE_FEATURES, LEARNING_PATH, ELEARNING_COURSE_URL } from "@/data/certificationProgramData";

export function CareersSection() {
  return (
    <div className="mb-10" data-testid="certification-careers-section">
      <h2 className="font-heading text-2xl font-semibold text-white mb-1 flex items-center gap-2"><TrendingUp className="w-5 h-5 text-amber-300" /> Where Data Cloud talent lands.</h2>
      <p className="text-sm text-slate-400 mb-5">Career Opportunities</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="certification-careers-grid">
        {CAREERS.map((c, i) => (
          <div key={i} className="glass-panel rounded-xl p-4 flex items-center justify-between gap-3" data-testid={`certification-career-${i}`}>
            <span className="text-sm font-medium text-slate-200">{c.role}</span>
            <span className="text-sm font-bold text-amber-300 shrink-0">{c.lpa}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export function FeaturesSection() {
  return (
    <div className="mb-10" data-testid="certification-features-section">
      <h2 className="font-heading text-2xl font-semibold text-white mb-1 flex items-center gap-2"><LayoutGrid className="w-5 h-5 text-amber-300" /> Support built into every week.</h2>
      <p className="text-sm text-slate-400 mb-5">Course Features</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="certification-features-grid">
        {COURSE_FEATURES.map((f, i) =>
          f.externalLink ? (
            <a key={i} href={ELEARNING_COURSE_URL} target="_blank" rel="noreferrer" className="glass-panel rounded-xl p-5 hover:border-amber-400/40 border border-transparent transition-colors" data-testid="certification-self-paced-videos-feature-link">
              <p className="text-sm font-semibold text-amber-300 mb-1.5 flex items-center gap-1.5">{f.title} <ExternalLink className="w-3 h-3" /></p>
              <p className="text-xs text-slate-400 leading-relaxed">{f.desc}</p>
            </a>
          ) : (
            <div key={i} className="glass-panel rounded-xl p-5" data-testid={`certification-feature-${i}`}>
              <p className="text-sm font-semibold text-white mb-1.5">{f.title}</p>
              <p className="text-xs text-slate-400 leading-relaxed">{f.desc}</p>
            </div>
          )
        )}
      </div>
    </div>
  );
}

export function LearningPathSection() {
  return (
    <div className="mb-10" data-testid="certification-learning-path-section">
      <h2 className="font-heading text-2xl font-semibold text-white mb-1 flex items-center gap-2"><Route className="w-5 h-5 text-amber-300" /> Beginner to job-ready, mapped week by week.</h2>
      <p className="text-sm text-slate-400 mb-5">Learning Path</p>
      <div className="flex flex-col sm:flex-row gap-3" data-testid="certification-learning-path-list">
        {LEARNING_PATH.map((s, i) => (
          <div key={i} className="glass-panel rounded-xl p-4 flex-1" data-testid={`certification-learning-path-${i}`}>
            <div className="flex items-center gap-2 mb-1.5">
              <span className="w-6 h-6 rounded-full bg-amber-400/15 border border-amber-400/30 text-amber-300 text-[11px] font-bold flex items-center justify-center shrink-0">{i + 1}</span>
              <span className="text-[10px] font-bold uppercase tracking-wide text-amber-300">{s.level}</span>
            </div>
            <p className="text-xs font-semibold text-white leading-tight mb-1">{s.title}</p>
            <p className="text-[11px] text-slate-500">{s.weeks}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
